import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Route, Switch } from 'react-router-dom';
import { isPhone } from 'utils/mobileDetect';
import RoutesUtils from 'utils/RoutesUtils.class';

import { Navigation } from './components';
import routes from './routes';

const showNavigation = pathname => {
  return (
    !pathname.match(/\/careers\/.+/)
    && !pathname.match(/\/login/)
    && !pathname.match(/\/signup/)
    && !pathname.match(/\/steps/)
  );
};

export const Landing = props => {
  const isMobileVersion = isPhone();
  const pathname = props.location.pathname;

  return (
    <Fragment>
      {showNavigation(pathname) && <Navigation isMobile={isMobileVersion} />}

      <Switch>
        {
          routes.map(route => (
            <Route
              key={route.path}
              path={`${route.path}`}
              exact={route.exact}
              render={renderProps => RoutesUtils.renderRoute(route, renderProps)}
            />
          ))
        }
      </Switch>
    </Fragment>
  );
};

Landing.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
};

export default Landing;



// WEBPACK FOOTER //
// ./src/components/landing/Landing.jsx